/**
 * sl-728o.3.1: Input Batch Session
 *
 * Explains "Which rows": the next matching row per run, or all matching rows
 * as one list up to a maximum.
 */
import type { useI18n } from '@affine/i18n';

import type { TutorialSession } from '../../types';

type I18n = ReturnType<typeof useI18n>;

export function createInputBatchSession(t: I18n): TutorialSession {
  return {
    id: 'automation:inputBatch',
    context: {
      targetAudience: 'technical',
      category: 'automation',
      tab: 'input',
    },
    steps: [
      {
        targetSelector: '[data-section="batch-size"]',
        title: t['com.streamlain.streamlain.coach.rows-mode.title'](),
        content: t['com.streamlain.streamlain.coach.rows-mode.content'](),
        animation: 'pulse',
      },
    ],
  };
}
